.bi{position:absolute;}